import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateGraphic,
  EmptyStateTitle,
  Spinner,
} from '@customerio/pluma-components/react';

export function CollectionImportingState() {
  return (
    <EmptyState>
      <EmptyStateGraphic>
        <Spinner />
      </EmptyStateGraphic>
      <EmptyStateTitle>Importing</EmptyStateTitle>
      <EmptyStateDescription>
        We have begun importing your file. This may take some time. Feel free to leave this page while the import is in
        progress.
      </EmptyStateDescription>
    </EmptyState>
  );
}
